<template>
  <v-sheet color="transparent" :width="mdAndDown ? '300px' : '400px'">
    <v-form @submit="searchSubmit">
      <v-text-field
        class="search-widget"
        color="secondary"
        append-icon="fa fa-search"
        v-model="q"
        hide-details
        @click:append="searchSubmit"
        type="text"
        placeholder="O que você procura?"
      ></v-text-field>

      <v-btn class="d-none" type="submit"></v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    q: "",
  }),
  computed: {
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    searchSubmit(event) {
      event.preventDefault();

      const query = {};
      query.q = this.q;

      this.$router.push({ path: "/produtos", query: query });
    },
  },
  watch: {
    $route() {
      if (this.q && !this.$route.query.q) this.q = "";
    },
  },
};
</script>
